/** Admin account roles (matches API `ModelAdmin.role`). */
export const ADMIN_ROLE = {
  VIEWER: 0,
  ADMIN: 1,
  SUBADMIN: 2,
  MARKETER: 3,
};

export function getStoredAdminRole() {
  const raw = localStorage.getItem("role");
  if (raw === null || raw === undefined || raw === "") return null;
  const n = parseInt(raw, 10);
  return Number.isNaN(n) ? null : n;
}

export function isMarketerReadOnly() {
  return getStoredAdminRole() === ADMIN_ROLE.MARKETER;
}

/** Routes marketers may open in the admin SPA (exact pathnames). */
export const MARKETER_ALLOWED_PATHNAMES = [
  "/dashboard",
  "/ai/dashboard",
  "/ai/parents",
  "/ai/subscription-plans",
  "/ai/subscribers",
  "/ai/clicked-subscribe",
  "/ai/metrics",
  "/ai/curriculum",
  "/ai/learning-paths",
  "/ai/feedback",
  "/ai/referral-codes",
  "/manage-parent",
  "/manage-child",
  "/manage-program",
  "/manage-partner",
];

const MARKETER_ALLOWED_PATH_PREFIXES = [
  "/ai/learning-paths/", // learning path editor (read-only for marketers)
  "/partner/dashboard/",
  "/partner/manage-parent/",
  "/partner/manage-child/",
  "/partner/manage-program/",
  "/partner/manage-report/",
  "/partner/manage-cohort/",
  "/partner/manage-access/",
];

export function isMarketerPathAllowed(pathname) {
  if (!pathname) return false;
  if (MARKETER_ALLOWED_PATHNAMES.includes(pathname)) return true;
  return MARKETER_ALLOWED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
